import ReactGA from 'react-ga';

const addEvent = (_category, _action, _label, _value = 0) => {
  ReactGA.event({
    category: _category,
    action: _action,
    label: _label,
    value: _value,
  });
};

export default {
  addEvent,
};
